import { jsx as _jsx } from "react/jsx-runtime";
import { StepLabel, Tooltip, styled } from '@mui/material';
import { PentairIconFlag } from './pentair-icon';
const ProgressStepperIconRoot = styled('div')(({ completed, active, theme }) => ({
    display: 'flex',
    height: 24,
    width: 24,
    borderRadius: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 13,
    lineHeight: 1,
    color: theme.palette.white.main,
    backgroundColor: completed ? theme.palette.green.main : theme.palette.softGray.main,
    ...(active && {
        color: theme.palette.white.main,
        backgroundColor: theme.palette.brightBlue.main,
    }),
}));
export const PentairProgressStepperIcon = ({ active, completed, icon, className, sx }) => {
    return (_jsx(ProgressStepperIconRoot, { completed: completed, active: active, className: className, sx: { cursor: completed ? 'pointer' : 'default !important', ...sx }, children: icon }));
};
export const PentairStepLabel = ({ isFinalStep, icon, children, ...props }) => {
    const label = (_jsx(StepLabel, { StepIconComponent: PentairProgressStepperIcon, ...props, icon: isFinalStep ? _jsx(PentairIconFlag, { size: "xs" }) : icon, sx: {
            '& .MuiStepLabel-iconContainer': {
                paddingRight: 0,
            },
            ...props.sx,
        } }));
    if (children) {
        return (_jsx(Tooltip, { title: children, placement: "top", children: label }));
    }
    return label;
};
